import type { Ref } from 'react';

import { Dialog } from '@ui/uikit/components/common/DialogV2';
import Spinner from '@ui/uikit/components/common/Loader/Loader';
import type { ModalProps } from '@ui/uikit/components/common/Modal';
import { Modal } from '@ui/uikit/components/common/Modal';
import { Typography } from '@ui/uikit/components/common/Typography';

import type {
  IsSqrvVotingPowerUsed,
  IsValidationFinished,
} from '../../ApplicationValidationSummary';
import styles from './ApplicationValidationVotesModal.module.scss';
import { ApplicationValidationVotesTable } from './ApplicationValidationVotesTable/ApplicationValidationVotesTable';
import type { ApplicationTableData } from './ApplicationValidationVotesTable/getApplicationValidationVotesTableColumns';

export interface VotesTableModel {
  selfData?: ApplicationTableData[];
  data?: ApplicationTableData[];
  isInitialLoading?: boolean;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  loadMoreRef?: Ref<HTMLDivElement>;
  votersCount?: number;
}

export interface ApplicationValidationVotesModalProps
  extends ModalProps,
    VotesTableModel,
    IsValidationFinished,
    IsSqrvVotingPowerUsed {}

export const ApplicationValidationVotesModal = ({
  isOpen = false,
  onClose,
  selfData = [],
  data = [],
  isInitialLoading = false,
  hasNextPage = false,
  isFetchingNextPage = false,
  loadMoreRef,
  votersCount = 0,
  isSqrvVotingPowerUsed = false,
  isValidationFinished = false,
}: ApplicationValidationVotesModalProps) => {
  const formattedVotersCount = new Intl.NumberFormat('en-US', {
    useGrouping: true,
    maximumFractionDigits: 0,
  }).format(votersCount);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Dialog variant="long" size="medium">
        <Dialog.Header>
          <Typography variant="h3" component="span">
            {formattedVotersCount} Voters
          </Typography>
        </Dialog.Header>
        <Dialog.Body>
          <ApplicationValidationVotesTable
            selfData={selfData}
            data={data}
            isLoading={isInitialLoading && data.length === 0}
            isValidationFinished={isValidationFinished}
            isSqrvVotingPowerUsed={isSqrvVotingPowerUsed}
          />
          {(hasNextPage || isFetchingNextPage) && (
            <div ref={loadMoreRef} className={styles.spinner}>
              {isFetchingNextPage && <Spinner size="md" />}
            </div>
          )}
        </Dialog.Body>
      </Dialog>
    </Modal>
  );
};
